import React from 'react';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { buttonPreloader as ButtonPreloader } from 'ui/views/generic/buttonPreloader';
 *
 * // render
 * <ButtonPreloader propName='propValue'/>
 */
export const buttonPreloader = ( props ) => {

	const style = {
		width: `${ props.radius }px`,
		height: `${ props.radius }px`
	};
    return (
        <div className='ui-button-preloader' style = { style }/>
    );
};

// set display name
buttonPreloader.displayName = 'buttonPreloader';

// set default props
buttonPreloader.defaultProps = {
	radius: 20
};

// prop types
buttonPreloader.propTypes = {};
